var ReactDOM;
try {
  ReactDOM = require('react-dom/client');
} catch (error) {
  ReactDOM = require('react-dom');
}
export default function Render(containid, node) {
  if (ReactDOM.createRoot) {
    var root = ReactDOM.createRoot(containid);
    root.render(node);
  } else if (ReactDOM.render) {
    ReactDOM.render(node, containid);
  }
}